export const BACKEND_IP = window.location.hostname;
export const BACKEND_PORT = window.location.port;
export const WEBSOCKET_PROTOCOL = (window.location.protocol === "https:" ? "wss://" : "ws://");

export const API_URL = window.location.protocol + "//" + BACKEND_IP + ":" + BACKEND_PORT;
export const WEBSOCKET_URL = WEBSOCKET_PROTOCOL + BACKEND_IP + ":" + BACKEND_PORT;
